import { sortBy } from 'lodash/fp';
import { useMemo } from 'react';
import { useListLocalVariantsQuery } from '../../../api/queries/listLocalVariants';
import { LocalVariantSortingField, SortingOrder } from '../../../api/types';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import useTranslatedString from '../../../utilities/useTranslatedString';

const useVariantFilter = () => {
    const translate = useTranslatedString();
    const company = useCompany(true);
    const { data } = useListLocalVariantsQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            pagination: { offset: 0, limit: 100 },
            sort: {
                field: LocalVariantSortingField.Order,
                order: SortingOrder.Asc,
            },
            filter: { companyId: company?.id },
        },
    });

    return useMemo(
        () =>
            sortBy(
                'text',
                data?.list?.items.map(vehicle => ({
                    text: translate(vehicle.name),
                    value: vehicle.name.defaultValue,
                })) || []
            ),
        [data, translate]
    );
};

export default useVariantFilter;
